/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Profile_ConcentratedInputs */

const en_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I like to make concentrated bets.`)
};

const de_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich setze gern auf konzentrierte Positionen.`)
};

const pt_br2_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gosto de fazer apostas concentradas.`)
};

const tr_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belirli alanlara yoğunlaşan yatırımlar yapmayı severim.`)
};

const zh_cn2_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我喜欢集中押注。`)
};

const zh_hk2_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我喜歡集中投資。`)
};

const ko_kr2_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 투자하는 것을 좋아합니다.`)
};

const ru_ru2_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мне нравятся концентрированные инвестиции.`)
};

const es_419_onboarding_v1_profile_concentrated = /** @type {(inputs: Onboarding_V1_Profile_ConcentratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me gusta hacer apuestas concentradas.`)
};

/**
* | output |
* | --- |
* | "I like to make concentrated bets." |
*
* @param {Onboarding_V1_Profile_ConcentratedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_profile_concentrated = /** @type {((inputs?: Onboarding_V1_Profile_ConcentratedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Profile_ConcentratedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_profile_concentrated(inputs)
	if (locale === "de") return de_onboarding_v1_profile_concentrated(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_profile_concentrated(inputs)
	if (locale === "tr") return tr_onboarding_v1_profile_concentrated(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_profile_concentrated(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_profile_concentrated(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_profile_concentrated(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_profile_concentrated(inputs)
	return es_419_onboarding_v1_profile_concentrated(inputs)
});